import { useLocation } from 'react-router';

import { useResolveWebView } from '@queries/useResolveWebView';

import { prefixes } from './prefixes';

export const usePrefixes = (originUrl: string): string[] | null => {
  const location = useLocation();

  const { resolveWebViewData, resolveWebViewError, resolveWebViewLoading } =
    useResolveWebView({ pathname: location.pathname, originUrl });

  if (resolveWebViewLoading) {
    return null;
  }
  if (resolveWebViewError) {
    return [];
  }

  if (resolveWebViewData?.resolveUrl) {
    return prefixes[resolveWebViewData.resolveUrl.type];
  }

  return [];
};
